import {Component, input}  from '@angular/core';
import {MindRecordLogIntf} from '@djsharkk/logr-types';
import {DialogEditBase}    from '../dialog-edit-base';

@Component({
			   selector   : 'app-dialog-edit-note',
			   imports    : [],
			   templateUrl: './dialog-edit-mind.component.html',
			   styleUrl   : './dialog-edit-mind.component.css'
		   })
export class DialogEditMindComponent extends DialogEditBase<MindRecordLogIntf> {
	rec = input.required<MindRecordLogIntf>();
}
